import React from "react";
import { Box, Text, List, ListItem, ListIcon } from "@chakra-ui/react";
import { FcOpenedFolder } from "react-icons/fc";

function SidebarFolder({
  folder,
  setSelectedFolder,
  level = 0,
  handleFolderClick,
}) {
  return (
    <Box w="20%" h="100%" bg="gray.100" p={4} rounded="xl">
      <Text fontWeight="bold" mb={2}>
        Folders
      </Text>
      <List spacing={4} mt={5}>
        {folder.sub_folders.map((subFolder, index) => (
          <SubfolderItem
            key={index}
            subFolder={subFolder}
            setSelectedFolder={setSelectedFolder}
            onClick={() => handleFolderClick(subFolder)}
            level={level}
            handleFolderClick={handleFolderClick}
          />
        ))}
      </List>
    </Box>
  );
}

function getNameByModuleType(value) {
  if (value === "23") {
    return "US Driver License";
  } else if (value === "5") {
    return "PHSP Argeement";
  } else if (value === "4") {
    return "Managed Care Contract";
  } else if (value === "2") {
    return "Assesment Worksheet Form";
  } else {
    return value;
  }
}

export function SubfolderItem({
  subFolder,
  setSelectedFolder,
  onClick,
  level,
  handleFolderClick,
}) {
  const hasSubfolders = subFolder.sub_folders.length > 0;

  const marginLeft = level * 20;

  return (
    <>
      <ListItem
        onClick={onClick}
        cursor="pointer"
        marginLeft={`${marginLeft}px`}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <ListIcon height={6} width={6} as={FcOpenedFolder} />
          {getNameByModuleType(subFolder.name)}
        </Box>
        <Box
          w={5}
          h={5}
          bg="blue.100"
          rounded="full"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Text fontSize={10}>
            {subFolder.folder_contents.filter((str) => str !== "").length}
          </Text>
        </Box>
      </ListItem>
      {hasSubfolders && (
        <List spacing={4} mt={1}>
          {subFolder.sub_folders.map((nestedSubFolder, index) => (
            <SubfolderItem
              key={index}
              subFolder={nestedSubFolder}
              setSelectedFolder={setSelectedFolder}
              onClick={() => handleFolderClick(nestedSubFolder)}
              level={level + 1}
            />
          ))}
        </List>
      )}
    </>
  );
}

export default SidebarFolder;
